import { staticSettings } from "@montana/helpers/static-settings.helper";
import { createServiceFunction } from "../http";
import { IProductPricesRequest } from "@montana/models/generated/cms.interface";

export const fetchProductInfo = createServiceFunction((productId: string, language: string, customerType: string) => {
    const url = `${staticSettings.apiUrl}/api/products/product-info/${language}/${productId}/${customerType}`;

    return f => f(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});

export const fetchPrices = createServiceFunction((code: string, request: IProductPricesRequest) => {
    const url = `${staticSettings.apiUrl}/api/products/${code}/prices`;

    return f => f(url, {
        method: "POST",
        body: JSON.stringify(request),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});

export const fetchAllProductAccessoryPrices = createServiceFunction((accessoryCodes?: string[]) => {
    const url = `${staticSettings.apiUrl}/api/products/accessories/prices`;

    return f => f(url, {
        method: "POST",
        body: JSON.stringify(accessoryCodes),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});

export const fetchFromPrice = createServiceFunction((marketId: string | undefined, productCode: string) => {
    const url = `${staticSettings.apiUrl}/api/products/product-info/from-price/${marketId}/${productCode}`;

    return f => f(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});